<template>
  <MasterModalBase
    width-lg
    :action-buttons="'true'"
    class="invoicelayout-master-modal"
    @close-modal="close"
  >
    <template v-slot:title>
      <div>
        <span v-if="isEdit || selectedBrand && selectedBrand.name !== ''">{{ selectedBrand.name }}</span>
        <span v-else>{{ $gettext('New trade name') }}</span>
      </div>
    </template>

    <template v-slot:navbar>
      <div class="buttons-wrap" :class="[(stage === 'edit') ? 'active' : '']">
        <div class="buttons-tt-wrap">
          <GekkoButton
            :text="$gettext('Invoice Information')"
            @click.prevent="loadView('edit')"
            :variant="'modal-tab'"
            :class="['px-0', (stage === 'edit') ? 'active' : '']"
          />
        </div>
      </div>
      <div class="buttons-wrap" :class="[(stage === 'design') ? 'active' : '']">
        <div class="buttons-tt-wrap">
          <GekkoButton
            :text="$gettext('Invoice Design')"
            :disabled="!isEdit"
            @click.prevent="loadView('design')"
            :variant="'modal-tab'"
            :class="['px-0', (stage === 'design') ? 'active' : '']"
          />
        </div>
      </div>
    </template>

    <template v-slot:maincontent>
      <div class="master-invoicelayout-modal-view-wrap">
        <div class="master-invoicelayout-modal-view">
          <div v-if="stage === 'edit'" class="view-wrap" :class="['view-wrap--' + stage]">
            <BrandCreateEdit ref="brand-create-edit" :show-pdf-preview="isEdit" @created="brandCreated" @edited="brandEdited" @edit-design="stage = 'design'" />
          </div>
          <div v-if="stage === 'design'" class="view-wrap" :class="['view-wrap--' + stage]">
            <InvoiceDesign ref="invoicelayout-design" @updated="updatedDesign"/>
          </div>
        </div>
      </div>
    </template>

    <template v-slot:actions>
      <div class="bottom-action-btns--wrap">

        <!-- save brand -->
        <GekkoButton
          v-if="stage === 'edit'"
          @click="close"
          :text="$gettext('Close')"
          variant="outline-primary"
        />
        <GekkoButton
          v-if="stage === 'edit'"
          @click="$refs['brand-create-edit'].parentSubmit()"
          :text="$gettext('Apply Changes')"
          icon="fa-regular fa-floppy-disk"
          variant="primary"
        />

        <!-- DESIGN -->
        <GekkoButton
          v-if="stage === 'design'"
          @click="$refs['invoicelayout-design'].saveChanges()"
          :text="$gettext('Apply Changes')"
          icon="fa-regular fa-credit-card"
          variant="primary"
        />
        
      </div>
    </template>
  </MasterModalBase>
</template>
<script>
import { mapGetters } from "vuex"

import TitleBar from "@/components/TitleBar"
import GekkoButton from "@/components/GekkoButton"
import MasterModalBase from "@/components/base_components/MasterModalBase"

import BrandCreateEdit from "@/components/brands/BrandCreateEdit"
import InvoiceDesign from "@/views/settings/InvoiceDesign"

import BrandService from "@/store/services/brand.service"

export default {
  name: 'BrandModal',
  components: { 
    MasterModalBase, 
    GekkoButton, 
    TitleBar, 
    BrandCreateEdit,
    InvoiceDesign
  },
  data () {
    return {
      stage: 'edit',
      actionButtons: 'edit'
    }
  },
  computed: {
    ...mapGetters({
      availableBrands: 'brands/getAvailableBrands',
      selectedBrand: 'brands/getSelectedBrand',
    }),
    isEdit () {
      return !!(this.selectedBrand && this.selectedBrand.id)
    }
  },
  mounted () {
    document.body.classList.add('modal-on')
  },
  methods: {
    close () {
      this.$emit('close')
      document.body.classList.remove('modal-on')
    },
    brandCreated (value) {
      this.$emit('created', value)
      this.close()
    },
    brandEdited () {
      this.$emit('edited')
      // this.close()
    },
    deleteBrand () {
      BrandService.destroy(this.selectedBrand.id).then(() => {
        this.$emit('deleted')
        this.close()
      })
    },
    updatedDesign () {
      this.$emit('updated-design')
      // this.close()
      this.loadView('edit')
    },
    loadView (view) {
      this.stage = view
      this.actionButtons = view
    },
  }
}
</script>
<style lang="scss">
  .invoicelayout-master-modal {
    .master-invoicelayout-modal-view-wrap {
      width: 100%;
      height: 100%;
      position: relative;
      min-height: 100%;
      .master-invoicelayout-modal-view {
        height: 100%;
        display: block;
        .view-wrap {
          height: 100%;
          &--edit {
          }
        }
      }
    }
  }
</style>
